// Feature Documentation: docs/features/refactor-strict-analysis-and-carrier-data.md
import React from 'react';
import { useParams } from 'react-router-dom';
import { useFeatureFlags } from '../FeatureFlags';
import NMAStrictAnalysis from './NMAStrictAnalysis';
import USNStrictAnalysis from './USNStrictAnalysis';
import DefaultStrictAnalysis from './DefaultStrictAnalysis';

const StrictAnalysisRouter = () => {
  const { caseId } = useParams();
  const { featureFlags } = useFeatureFlags();
  
  const orgName = featureFlags?.menu_version?.toLowerCase() || '';
  const isNMA = orgName === 'nma' || orgName.includes('revedy');
  const isUSN = orgName === 'us neuro' || orgName === 'usneuro';
  
  // Route to the correct org-specific wrapper
  if (isNMA) {
    return <NMAStrictAnalysis caseId={caseId} />;
  }
  
  if (isUSN) {
    return <USNStrictAnalysis caseId={caseId} />;
  }
  
  // Fallback for MPH and others
  return <DefaultStrictAnalysis caseId={caseId} />;
};

export default StrictAnalysisRouter;
